// @ts-nocheck

import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  useMediaQuery, useTheme
} from "@mui/material";

interface Option {
  value: string;
  label: string;
  id?: string;
}

interface CustomSelectFieldProps {
  label: string;
  name: string;
  options: Option[];
  value: string;
  onChange: any;
  size?: any;
  helperText?: string;
  disabled?: boolean;
  dataTestid?: string;
  isDocument?: boolean;
  required?: boolean;
  error?: any;
  sx?:any
}

const CustomSelectField: React.FC<CustomSelectFieldProps> = ({
  label,
  name,
  options = [],
  value,
  onChange,
  size = "small",
  error,
  helperText,
  disabled = false,
  dataTestid,
  isDocument,
  required = false,
  sx,
  ...props
}) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedValue = event.target.value as string;
    const selectedOption = options.find(
      (option) => option.value === selectedValue
    );
    const selectedId = selectedOption?.id || null;
    onChange(
      event,
      { value: selectedValue, label: selectedValue },
      selectedId,
      selectedOption
    );
  };

  const handleDocumentChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedValue = event.target.value as string;
    const selectedOption = options.find(
      (option) => option.value === selectedValue
    );
    onChange(event, name, selectedOption);
  };

  const selectId = `select-${name}`;
  const labelId = `label-${name}`;

  return (
    <FormControl
      {...props}
      fullWidth
      size={size}
      disabled={disabled}
      variant="outlined"
      error={error}
      required={required}
      sx={sx}
    >
      <InputLabel 
        id={`label-${name}`}
        shrink={!!value}
      >
        {label}
      </InputLabel>
      <Select
        labelId={`label-${name}`}
        id={props.id || `select-${name}`}
        label={label}
        data-testid={dataTestid || "select-test"}
        name={name}
        value={value}
        onChange={isDocument ? handleDocumentChange : handleChange}
        displayEmpty
        notched={!!value}
        inputProps={{
          'aria-label': label,
          'aria-labelledby': labelId,
        }}
        sx={{
          "& .MuiPopover-paper": {
            left: "960px !important",
          },
          "& .MuiPopover-paper": {
            minWidth: { md: "500px", sm: "210px" },
          },
          "& .MuiMenuItem-root": {
            minHeight: { md: "48px", sm: "32px" },
          },
          "& .MuiSelect-select": {
            "&.MuiInputBase-input": {
              color: value ? 'inherit' : 'text.secondary',
            }
          }
        }}
        MenuProps={{
          PaperProps: {
            style: {
              // zIndex: 9999999,
              minWidth: isMd ? "10%" : isSm ? "40%" : "70%",
              maxWidth: isMd ? "45%" : isSm ? "40%" : "70%", 
            },
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "right"
          },
        }}
      >
        
        {options.map((option, index) => (
          <MenuItem key={index} id={option.id || option.value} value={option.value} sx={{textWrap:"auto"}}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CustomSelectField;
